import React from "react";

export const getProjectsSteps = () => [
  {
    target: () => document.querySelector('[data-tour-id="project-select"]'),
    title: "Projetos",
    description:
      "Gerencie projetos para agrupar Sincronizações, Relatórios e Agrupamento de relatórios, organizando tudo por escopo.",
  },
  {
    target: () =>
      document.querySelector('[data-tour-id="view-all-projects-btn"]'),
    title: "Visualizar todos os projetos",
    description: "Abra a visão geral para navegar por todos os projetos.",
    nextButtonProps: {
      children: "Próximo",
      onClick: () => {
        const el = document.querySelector(
          '[data-tour-id="view-all-projects-btn"]'
        );
        if (el) el.click();
        setTimeout(() => window.dispatchEvent(new Event("resize")), 120);
      },
    },
  },
  {
    target: () =>
      document.querySelector('[data-tour-id="projects-view-modal"]'),
    title: "Lista de Projetos",
    description: "Aqui você tem uma visualização mais prática dos seus projetos, onde pode buscar, paginar e configurar seus projetos.",
    placement: "top",
    nextButtonProps: {
      children: "Próximo",
      onClick: () => {
        window.dispatchEvent(new Event("tour-close-view-projects"));
        setTimeout(() => window.dispatchEvent(new Event("resize")), 120);
      },
    },
    prevButtonProps: {
      children: "Anterior",
      onClick: () => {
        window.dispatchEvent(new Event("tour-close-view-projects"));
        setTimeout(() => window.dispatchEvent(new Event("resize")), 120);
      },
    },
  },
  {
    target: () => document.querySelector('[data-tour-id="project-select"]'),
    title: "Selecionar projeto ativo",
    description:
      "Selecione um projeto para filtrar Sincronizações e Relatórios. Use 'Todos os projetos' para ver tudo.",
  },
  {
    target: () => document.querySelector('[data-tour-id="new-project-btn"]'),
    title: "Criar novo projeto",
    description: "Abra o fluxo de criação de projeto.",
    nextButtonProps: {
      children: "Próximo",
      onClick: () => {
        const el = document.querySelector('[data-tour-id="new-project-btn"]');
        if (el) el.click();
        setTimeout(() => window.dispatchEvent(new Event("resize")), 120);
      },
    },
  },
  {
    target: () =>
      document.querySelector('[data-tour-id="project-logo-upload"]'),
    title: "Logo do Projeto",
    description: "Envie ou altere o logo para identificar melhor seu projeto.",
    prevButtonProps: {
      children: "Anterior",
      onClick: () =>
        window.dispatchEvent(new Event("tour-close-create-project")),
    },
  },
  {
    target: () => document.querySelector('[data-tour-id="project-form"]'),
    title: "Informações do Projeto",
    description: "Preencha nome, CNPJ, contato e telefone.",
  },
  {
    target: () => document.querySelector('[data-tour-id="project-save-btn"]'),
    title: "Salvar / Criar Projeto",
    description: "Finalize a criação ou salve as alterações do projeto.",
    nextButtonProps: {
      children: "Próximo",
      onClick: () =>
        window.dispatchEvent(new Event("tour-close-create-project")),
    },
  },
];
